/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of privcats (patients) to display or load privcats */


(function () {
  'use strict';
  angular.module('vcfinance.privcat')
    .component('privcatentrylist', {
      restrict: 'E',
      bindings: {
        privcatentries: '<?'
      },
      template: `
        <table class="table table-striped">
          <thead>
          <tr>
            <th>Kürzel</th>
            <th>Bezeichnung</th>
            <th>Aktion</th>
          </tr>
          </thead>
          <tr ng-repeat="entry in vm.privcatentries">
            <td>{{entry.shortcut}}</td>
            <td>{{entry.name}}</td>
            <td>
              <button class="btn btn-primary" ng-click="vm.editPrivcatEntry(entry)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>
              <button class="btn btn-danger" ng-click="vm.removeEntry(entry)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>
            </td>
          </tr>
        </table> 
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Privcat', 'PrivcatHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, Privcat, PrivcatHelper, vertxEventBusService) {
          let vm = this;
          vm.editPrivcatEntry = PrivcatHelper.editPrivcatEntry;
          vm.removeEntry = removeEntry;
          
          vm.$onInit = function () {
            
            // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
            if (angular.isUndefined(vm.privcatentries)) {
              vm.privcatentries = Privcat.$search({type: 'entry', active: true});
            }
          }; // $onInit()
          
          
          function removeEntry(entry) {
            entry.active = false;
            entry.$save();
          }

          const privcatUpdateHandler =function (message) {
            $log.debug('debug: privcat update received: ', message);
            let messages = message.split(':');
            if (angular.isDefined(vm.privcatentries)){
              vm.privcatentries.$refresh().$then(function () {
                $log.debug('debug: privcatentrylist refreshed');
              }, function (error) {
                $log.debug('debug: privcatentrylist refresh failed: ', error);
              });
            }
          };

          vertxEventBusService.on('privcat.update', {}, privcatUpdateHandler);

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('privcat.update', {}, privcatUpdateHandler);
          };




        }] // controller
    }); // component
  
  // klammerfriedhof
}());